import { useEffect, useRef } from "react";

export function CollaborationCursors({ cursors, viewport }) {
  return (
    <div className="pointer-events-none absolute inset-0 z-[35] overflow-hidden" data-testid="collab-cursors">
      {Object.entries(cursors).map(([id, cursor]) => {
        if (!cursor.x && cursor.x !== 0) return null;
        // Convert flow coordinates to screen coordinates using viewport
        const screenX = cursor.x * (viewport?.zoom || 1) + (viewport?.x || 0);
        const screenY = cursor.y * (viewport?.zoom || 1) + (viewport?.y || 0);

        return (
          <CollabCursor
            key={id}
            x={screenX}
            y={screenY}
            name={cursor.name}
            color={cursor.color}
          />
        );
      })}
    </div>
  );
}

function CollabCursor({ x, y, name, color }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.style.transform = `translate(${x}px, ${y}px)`;
    }
  }, [x, y]);

  return (
    <div
      ref={ref}
      className="absolute top-0 left-0 transition-transform duration-150 ease-out"
      style={{ transform: `translate(${x}px, ${y}px)` }}
    >
      {/* Cursor arrow SVG */}
      <svg width="16" height="20" viewBox="0 0 16 20" fill="none" style={{ filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.15))" }}>
        <path d="M0.5 0.5L15.5 10.5L8 11.5L5 19.5L0.5 0.5Z" fill={color} stroke="white" strokeWidth="1" />
      </svg>
      {/* Name tag */}
      <div
        className="absolute left-4 top-4 px-2 py-0.5 rounded-md text-[9px] font-bold text-white whitespace-nowrap shadow-sm"
        style={{ backgroundColor: color }}
      >
        {name}
      </div>
    </div>
  );
}
